import { render, staticRenderFns } from "./Manutencao.vue?vue&type=template&id=8ff97286&scoped=true"
import script from "./Manutencao.vue?vue&type=script&lang=js"
export * from "./Manutencao.vue?vue&type=script&lang=js"
import style0 from "./Manutencao.vue?vue&type=style&index=0&id=8ff97286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff97286",
  null
  
)

export default component.exports